import { ChangeDetectorRef, Component, Injector, OnDestroy, TemplateRef, ViewChild, HostListener } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { IonSegment, ModalController, ToastController, NavParams } from "@ionic/angular";
import { GeolocationHelpers } from "src/app/helpers/geolocataion-helpers";
import { IAddress, IAddressRange } from "src/app/shared/services/address.service";
import { AlertService } from "src/app/shared/services/alert.service";
import { GoogleApiService } from "src/app/shared/services/google-api.service";
import { Geolocation } from '@capacitor/geolocation'; // new package used here
import { LoaderService } from "src/app/shared/services/loader.service";
import { SettingService } from "src/app/shared/services/setting.service";
import { finalize } from 'rxjs/operators';
import { MenuService } from "src/app/store/services/menu.service";
import { Storage } from '@ionic/storage';
import { IHours, IStore, IStorePhone, StoreService } from "src/app/store/services/store.service";
import { AddressEditorModalComponent } from "src/app/shared/components/address-editor-modal/address-editor-modal.component";
import { FormControl, FormGroup } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ICreateReservation, IEmployee, IEmployeeSchedule, IFindTableAvailability, ILayoutDetails, IReservationSectionPackage, ISection, ISectionPackage, IStoreLayoutConfig, ITable, ReservationService } from "src/app/shared/services/reservation.service";
import { ReservationCartModalComponent } from "src/app/store/modals/reservation-cart/reservation-cart-modal.component";
import { ReservationCheckoutModalComponent } from "src/app/store/modals/reservation-checkout-modal/reservation-checkout-modal.component";
import { AuthService } from "src/app/auth/services/auth.service";
import { ProceedAsGuestModalComponent } from "src/app/auth/modals/proceed-as-guest-modal/proceed-as-guest-modal.component";
import { DomSanitizer } from "@angular/platform-browser";
import { ICustomerReservationTransactionEmail, ReservationReceiptComponent } from "src/app/store/components/reservation-receipt/reservation-receipt.component";
import { IReservationConfiguration, ReservationConfigurationService } from "src/app/shared/services/reservation-configuration.service";
import { MatDialog } from "@angular/material/dialog";
import { NotificationServiceService, INotifications } from 'src/app/store/services/notification-service.service';
import { NotificationBellServiceService } from "src/app/store/services/notification-bell-service.service";
import { AnalyticsService } from 'src/app/shared/services/analytics.service';
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { IconService } from "src/app/shared/services/icon.service";
import { TranslationService } from "src/app/shared/services/translation.service";
export interface IGeopoint {
  latitude: number;
  longitude: number;
}

@Component({
    selector: 'merchant-reservation',
    templateUrl: './reservation-page.component.html',
    styleUrls: ['./reservation-page.component.scss'],
    standalone: false
})
  
  
export class ReservationComponent implements OnDestroy {
  title: string = 'Nav.Reservation';
  stores: IStore[] = [];
  _stores: IStore[] = [];
  storeSections : ISection[] = [];
  storeEmployees : IEmployee[] = [];
  selectedEmployee : IEmployee;
  tempstoreEmployees : IEmployee[] = [];
  selectedSection : ISection = undefined;
  page: number = 1;
  pageSize: number = 20;
  //orderType: OrderType = null;
  pickupValue: string;
  address: IAddress;
  segmentValue: string = 'address';
  isRetail: boolean=false;
  storeValidRange: IStore[] = [];
  doorDashDriveAverageRadius: number = 13;
  isDoorDashDrivePossible : boolean = false;
  selectedStore : IStore = undefined;
  reservationPage : boolean = false;
  reservationDate : Date;
  reservationHour : string = "";
  reservationGuests : number = 2;
  availability: boolean = false;
  guestName : string = "";
  guestPhone : string = "";
  guestEmail : string = "";
  reservationSuccessfull : boolean = false;
  countChildren : number = 0;
  countHighChair : number = 0;
  countBooster : number = 0;
  specialRequests : string = "";
  countSelectedPackages : number = 0;
  reservationSectionPackages: IReservationSectionPackage[] = [];
  public storeLayout : IStoreLayoutConfig;
  errorMessage : boolean = false;
  reservationClicked:boolean = false;
  showavavailableTimes:boolean = false;
  availableTimes : Date[] = [];
  reservationConfig: IReservationConfiguration;
  refreshStoresInterval: any;
  clickedStorePhone: IStorePhone;
  selectedLayout : ILayoutDetails = undefined;
  
  // public maxDate = new Date(2060, 0, 1);
  public minDate : Date;
  public maxDate : Date;
  public startDate : Date;
  public totalGuests : number;

  public ChangedDate : boolean = false;

  disableHeader: boolean = false;
  isPopup: boolean = false;
  mobile: boolean = false;

  public dateForm = new FormGroup({
      start: new FormControl()
  });

  startUpdate() {
      this.startDate = this.dateForm.get('start').value;
  }
  onSubmit(){
    if(this.startDate === undefined ||  this.startDate == null ){
        this.openSnackBar("Please select date", "close");
        this.onReset();
        return;
    }
    // if(this.dateForm.invalid){
    //     this.openSnackBar("Please choose valid date", "close");
    //     this.onReset();
    //     return;
    // }
    
   // console.log(this.startDate);
  //  console.log(this.totalGuests);
    
  }
  onReset(){
    this.startDate = undefined;
  }
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action,{duration : 3000});
  }

  get formatedAddress() {
    if (!this.address)
      return "";
    
    if (this.address.streetDirection != undefined && this.address.streetDirection != '') {
      if (this.translationService.getLanguage().toLowerCase() == 'en') {
        return `${this.address.streetNumber} ${this.address.street} ${this.address.streetDirection} ${this.address.streetType}, ${this.address.city}`;
      } else if (this.translationService.getLanguage().toLowerCase() == 'fr') {
        return `${this.address.streetNumber} ${this.address.streetType} ${this.address.street} ${this.address.streetDirection}, ${this.address.city}`;
      }
      
    }

    if (this.translationService.getLanguage().toLowerCase() == 'en') {
      return `${this.address.streetNumber} ${this.address.street} ${this.address.streetType}, ${this.address.city}`;
    } else if (this.translationService.getLanguage().toLowerCase() == 'fr') {
      return `${this.address.streetNumber} ${this.address.streetType} ${this.address.street}, ${this.address.city}`;
    }
    

  }
  private _geopoint: IGeopoint;
  get geopoint(): IGeopoint {
    return this._geopoint;
  }

  set geopoint(value: IGeopoint) {
    this._geopoint = value;
    if (!value)
      return;

    this.stores.forEach(t => {
    
      t._distance = GeolocationHelpers.distance(value.latitude, value.longitude, t.address.latitude, t.address.longitude);
      
    })

    this.stores.sort((t, n) => t._distance - n._distance);
    this.resetStoreValidRange();
    this.stores.forEach(store => {
      this.isStoreRangeValid(store);
    });
  }

  get allowDelivery() {
    if (this.settingService.configuration) {
      return this.settingService.configuration.allowDelivery;
    }
  }
  
  get allowPickup() {
    if (this.settingService.configuration) {
      return this.settingService.configuration.allowPickup;
    }
  }



  @ViewChild(IonSegment)
  segment: IonSegment;

  valideNotification: number;
  AllNotifications: INotifications[];
  
  bellIcon: IconDefinition;

  getCurrentPath(): string {
    return this.router.url;
  }

  constructor(
    private storeService: StoreService,
    private modalController: ModalController,
    private googleApiService: GoogleApiService,
    //private geolocation: Geolocation,
    private storage: Storage,
    private loaderService: LoaderService,
    public settingService: SettingService,
    private cdRef: ChangeDetectorRef,
    private alert: AlertService,
    //public translate: TranslateService,
    private route: ActivatedRoute,
    private router: Router,
    private menuService: MenuService,
    private toastCtrl: ToastController,
    private snackBar: MatSnackBar,
    private reservationService: ReservationService,
    private reservationConfigurationService: ReservationConfigurationService,
    private authService: AuthService,
    public sanitizer: DomSanitizer,
    private dialog: MatDialog,
    public NotificationService: NotificationServiceService,
    public NotificationBellService: NotificationBellServiceService,
    private injector: Injector,
    private analytics: AnalyticsService,
    private iconService: IconService,
    public translationService: TranslationService
  ) {
    this.bellIcon = this.iconService.getIcon('bell')!;
  }

  async ngOnInit() {

    // Only access NavParams if running inside a modal
    const navParams = this.injector.get(NavParams, null);

    try {
      if(navParams.get('disableHeader') != undefined) {
        this.disableHeader = navParams.get('disableHeader');
        this.isPopup = true;
      }
    } catch (e) {

    }


    if (!this.isPopup) {
      var currentUrl = this.getCurrentPath();
      localStorage.setItem('Stateurl', currentUrl);
    } else {
      localStorage.setItem('Stateurl', 'popup-reservation');
    }
    



    this.analytics.UpdateLocation({url: "/reservation", ispopup: this.isPopup},  true, false);

    try {
      this.valideNotification = await this.NotificationService.notificationCount();
      this.AllNotifications = this.NotificationService.notifationArray;
    } catch (e) {
      console.log("error collecting Notification Data");
    }

    
    this.storage.remove('cart');
    localStorage.removeItem("deliveryAddress");
    this.minDate = new Date();
    this.maxDate = new Date(new Date().getFullYear(), new Date().getMonth() + 3, 1);
    this.reservationPage = false;
    const language=this.route.snapshot.paramMap.get('language');
    this.getStores();
    this.refreshStoresInterval = setInterval(() => {         
      this.refreshStores();
    }, 30000);
    if(language)
    {
      if(language === 'en' || language ==='fr')
        {
          localStorage.removeItem('lang');
          this.translationService.setLanguage(this.route.snapshot.params.language); 
          localStorage['lang']=this.route.snapshot.params.language
        }
        else {
          this.router.navigate(['/reservation']);
        }
    }

    if (window.innerWidth <= 500) {
      this.mobile = true;

      this.disableHeader = false;
    } else {
      this.mobile = false;

      this.disableHeader = true;
    }

    // temporarily. we'll need to set it up on the page soon
    (window as any).updateLoaderProgress(100);
    (window as any).finishAppShell?.();

  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  async getStores() {
    const loader = await this.loaderService.create();
    this.storeService.getStores()
      /*.pipe(finalize(async () => {
        await loader.dismiss();
      }))*/
      .subscribe((data: IStore[]) => {
        // this.stores = data;
        // this._stores = data;
        // this.stores.forEach(store => {
        //   this.showOpeningHours(store);         
        // });
        this.getStoresWithTablesAndReservation(data, loader);
      });
  }

  @HostListener('window:resize', ['$event'])  
  onResize(event) { 

    if (window.innerWidth <= 500) { // follows the value of the modal
      this.mobile = true;

      this.disableHeader = false;
    } else {
      this.mobile = false;

      this.disableHeader = true;
    }
  }  

  async getStoresWithTablesAndReservation(stores : IStore[], loader){
    await Promise.all(stores.map(async (element, index) => { 
      const data = await this.reservationService.GetStoreTablesDetails(element.id).toPromise();
      const config = await this.reservationConfigurationService.findReservationConfiguration(element.id).toPromise();
    
      if (data && config && config.useReservation) {
        this.stores.push(element);
        this._stores.push(element);
        this.showOpeningHours(element);
      }
    
      if (index === stores.length - 1) {
        if (stores.length === 1 && this.stores.length === 1) {
          if (this.isStoreRangeValid(this.stores[0])) {
            this.reservationStore(this.stores[0]);
          }
        }
      }
      
      
    }));

    //this loader comes from "getStores()"
    await loader.dismiss();

    // defaults to the setting from the configuration
    if(this.settingService.configuration.locationFiltering==1) {
      this.segmentValue='position';
      this.pickupValue='position';
      this.segmentChanged();
    } else if(this.settingService.configuration.locationFiltering==0) {
      this.pickupValue='address';
    }

    
  }

  refreshStores() {
    this.storeService.getStores().subscribe((stores: IStore[]) => {
      stores = stores.filter(s => s.lastOnline != null);
      for(let i = 0; i < stores.length; i++){
        let index = this.stores.findIndex(s => s.id == stores[i].id);
        if(index != -1){
          this.stores[index].lastOnline = new Date(stores[i].lastOnline);
        }
      }
    });
  }

  /*
  async segmentChanged() {
    if(this.segment)
    {
      this.segmentValue = this.segment.value;
    }
    if (this.segmentValue == 'position') {
      this.geopoint = null;

      const loader = await this.loaderService.create();
      await loader.present();

      this.geolocation.getCurrentPosition({ enableHighAccuracy: false, timeout: 20000 })
        .then(position => {
          this.geopoint = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          }
        })
        .catch((reason) => {
          let messageKey;
          if (reason.code == 1) //PositionError.PERMISSION_DENIED)
            messageKey = 'Geolocation.PermissionDenied';
          else if (reason.code == 2) //PositionError.POSITION_UNAVAILABLE)
            messageKey = 'Geolocation.PositionUnavailable';
          else if (reason.code == 3) //PositionError.TIMEOUT)
            messageKey = 'Geolocation.Timeout';

          if (messageKey)
            this.alert.showTranslate(messageKey);
          else
            this.alert.showUnexpectedErrorMsg();
        })
        .finally(() => {
          loader.dismiss();
        });

    } else if (this.segmentValue == 'address' || this.segmentValue=='') {
      this.geopoint = null;

      if (this.address) {
        this.googleApiService.getAddressGeometry(this.address)
          .subscribe((result) => {
            this.geopoint = {
              latitude: result.lat,
              longitude: result.lng
            }
          
            // this.stores.forEach(store => {
            //   store = this.storeService.setDeliveryPrice(store, this.address,this.geopoint);
            // });
          });
      }
    }
  }
  */

  /*
  async segmentChanged() {
    if (this.segment) {
      //this.segmentValue = this.segment.value;
      this.segmentValue = String(this.segment.value);
      
    }

    if (this.segmentValue === 'position') {
      this.geopoint = null;

      const loader = await this.loaderService.create();
      await loader.present();

      try {
        const position = await Geolocation.getCurrentPosition({ enableHighAccuracy: false });

        this.geopoint = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude
        } as IGeopoint;

      } catch (error: any) {
        let messageKey = 'Geolocation.UnexpectedError';

        if (error?.code) {
          if (error.code === 1) messageKey = 'Geolocation.PermissionDenied';
          else if (error.code === 2) messageKey = 'Geolocation.PositionUnavailable';
          else if (error.code === 3) messageKey = 'Geolocation.Timeout';
        }

        this.alert.showTranslate(messageKey);
      } finally {
        loader.dismiss();
      }

    } else if (this.segmentValue === 'address' || this.segmentValue === '') {
      this.geopoint = null;

      if (this.address) {
        this.googleApiService.getAddressGeometry(this.address)
          .subscribe((result) => {
            this.geopoint = {
              latitude: result.lat,
              longitude: result.lng
            } as IGeopoint;

            // Optional: recalculate store delivery prices
            // this.stores.forEach(store => {
            //   store = this.storeService.setDeliveryPrice(store, this.address, this.geopoint);
            // });
          });
      }
    }
  }
    */
  async segmentChanged() {
    if (this.segment) {
      //this.segmentValue = this.segment.value;
      this.segmentValue = String(this.segment.value);
       
    }

    // --- When user selects "position" ---
    if (this.segmentValue === 'position') {
      this.geopoint = null;

      const loader = await this.loaderService.create();
      await loader.present();

      try {
        // Ask permission if needed (safe on web)
        await Geolocation.requestPermissions();

        const position = await Geolocation.getCurrentPosition({
          enableHighAccuracy: false,
          timeout: 20000
        });

        this.geopoint = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        };

      } catch (reason: any) {
        let messageKey;

        // Capacitor uses same codes as W3C Geolocation API
        if (reason.code === 1)
          messageKey = 'Geolocation.PermissionDenied';
        else if (reason.code === 2)
          messageKey = 'Geolocation.PositionUnavailable';
        else if (reason.code === 3)
          messageKey = 'Geolocation.Timeout';

        if (messageKey)
          this.alert.showTranslate(messageKey);
        else
          this.alert.showUnexpectedErrorMsg();

      } finally {
        loader.dismiss();
      }

      return;
    } 

    // --- When segment = address or empty ---
    if (this.segmentValue === 'address' || this.segmentValue === '') {
      this.geopoint = null;

      if (this.address) {
        this.googleApiService.getAddressGeometry(this.address)
          .subscribe(result => {
            this.geopoint = {
              latitude: result.lat,
              longitude: result.lng
            };

            // Optional:
            // this.stores.forEach(store => {
            //   store = this.storeService.setDeliveryPrice(store, this.address, this.geopoint);
            // });
          });
      }
    }
  }

  async beginChangeAddress() {
    const modal = await this.modalController.create({
      component: AddressEditorModalComponent,
      componentProps: {
        title: 'Store.Address',
        skipProvinceValidation: true
      }
    });

    modal.onWillDismiss()
      .then((result) => {
        if (result.data) {       
          this.resetStoreValidRange();
         
          this.address = result.data;
          //this.filterStoresOnPostalCode();

          //Cache the delivery address to access it later in the checkout process
          //this.storage.set("deliveryAddress", this.address);

          this.googleApiService.getAddressGeometry(result.data)
            .subscribe((result) => {
              this.geopoint = {
                latitude: result.lat,
                longitude: result.lng
              }
              this.resetStoreValidRange();
              
              this.stores.forEach(store => {

                this.isStoreRangeValid(store);
                //store = this.storeService.setDeliveryPrice(store, this.address,this.geopoint);
              });
              this.stores = this.storeValidRange.sort((t, n) => t._distance - n._distance);
            });
        }
      });

    await modal.present();
  }


  private resetStoreValidRange() {
    this.storeValidRange = [];
  }

  isStoreRangeValid(store: IStore) {
    this.storeValidRange.push(store);
    return true;
  }

  showOpeningHours(store: IStore) {
    this.storeService.setOpeningHours(store);
  }
  reservationStore(store:IStore){
    this.selectedStore = store;
    this.reservationDate = new Date();
    this.reservationHour = "";
    
    this.availability = false;
    this.guestName = "";
    this.guestPhone = "";
    this.guestEmail = "";
    this.reservationSuccessfull = false;
    this.countBooster = 0;
    this.countChildren = 0;
    this.countHighChair = 0;
    this.specialRequests = "";
    this.errorMessage = false;
    this.showavavailableTimes = false;
    this.reservationClicked = false;
    this.availableTimes = [];
    this.storeSections = [];
    this.storeEmployees = [];
    this.tempstoreEmployees = [];
    this.selectedSection = undefined;
    this.selectedEmployee = undefined;
    this.selectedLayout = undefined;
    this.countSelectedPackages = 0;
    this.reservationSectionPackages = [];

    this.reservationService.getLayoutInfo(store.id).subscribe(data=>{
      //debugger;
      this.storeLayout = data;
      //console.log(this.storeLayout);
      this.reservationService.getSections(store.id).subscribe(sectionsData =>{
        this.storeSections = sectionsData;
      });
      this.reservationService.getStoreEmployees(store.externalProviderId).subscribe(employees =>{
        this.storeEmployees = employees; 
        //this.tempstoreEmployees = this.storeEmployees;
        this.tempstoreEmployees = this.storeEmployees.filter(employee => employee.EmployeeSchedule.find(schedule => schedule.Day == this.reservationDate.getDay()) != undefined);

      });
      this.reservationPage = true;

      let openingandClosingHours : IHours = this.storeService.getStoreOpenHoursForDay(this.selectedStore, this.reservationDate.toDateString());
      this.selectedStore._openHour = openingandClosingHours.openHours;
      this.selectedStore._closedHour = openingandClosingHours.closeHours;


      ///////////////////////////////////////////////////////////////////
      // Automatically sets up the first layout and search for available times

      this.selectedLayout = this.storeLayout.LayoutDetails[0];
      if(!this.storeLayout.SectionsIncluded && !this.storeLayout.EmployeesIncluded){
        this.checkAvailableTimesForDate();
      }

      ///////////////////////////////////////////////////////////////////
    });
    this.reservationConfigurationService.findReservationConfiguration(store.id).subscribe(config => {
      this.reservationConfig = config;
    });
  }
  reservationClose(){
    this.reservationPage = false;
    this.selectedStore = undefined;
    this.reservationDate = undefined;
    this.reservationHour = "";
    this.reservationGuests = 1;
    this.availability = false;
    this.guestName = "";
    this.guestPhone = "";
    this.guestEmail = "";
    this.reservationSuccessfull = false;
    this.countBooster = 0;
    this.countChildren = 0;
    this.countHighChair = 0;
    this.specialRequests = "";
    this.reservationClicked = false;
    this.storeLayout = undefined;
    this.availableTimes = [];
    this.storeSections = [];
    this.storeEmployees = [];
    this.tempstoreEmployees = [];
    this.errorMessage = false;
    this.selectedSection = undefined;
    this.selectedLayout = undefined;
    this.showavavailableTimes = false;
    this.countSelectedPackages = 0;
    this.reservationSectionPackages = [];

    if(this.stores.length == 1){
      if(this.isStoreRangeValid(this.stores[0])){
        this.reservationStore(this.stores[0]);
      }
    }
  }
  updateReservationGuests(newGuestCount){
    this.reservationGuests = newGuestCount;
    this.showavavailableTimes = false;
  }
  selectedSectionUpdate(value : ISection){
    this.selectedSection = value;
    this.showavavailableTimes = false;
    this.tempstoreEmployees = [];
    if(value.Employee){
      value.Employee.forEach(element => {
        this.tempstoreEmployees.push(this.storeEmployees.find(employees => employees.EmployeeId == element));
        this.tempstoreEmployees = this.tempstoreEmployees.filter(employee => employee.EmployeeSchedule.find(schedule => schedule.Day == this.reservationDate.getDay()) != undefined);
      });
    }
    this.reservationSectionPackages = [];
    if(this.reservationConfig && this.reservationConfig.usePrepay && value.Packages){
      value.Packages.forEach(element => {
        if(element.IsActive){
          this.reservationSectionPackages.push({ 
            ItemId: element.ItemId, 
            ItemName: element.ItemName, 
            ItemNumber: element.ItemNumber,
            Description: element.Description,
            Price: element.Price, 
            TaxEligible: element.TaxEligible,
            ItemImageShortName: element.ItemImageShortName,
            Quantity: 0,
            SpecialRequest: ''
          });
        }
      });
    }
  }
  selectedEmployeeUpdate(value : IEmployee){
    this.selectedEmployee = value;
    this.showavavailableTimes = false;
    //console.log(this.selectedEmployee);
  }
  selectedLayoutUpdate(value : ILayoutDetails){
    this.selectedLayout = value;
    this.showavavailableTimes = false;
    //console.log(this.selectedEmployee);
  }

  getOpenHours(newValue : Date){

    this.reservationDate = newValue;

    try {
      let openingandClosingHours : IHours = this.storeService.getStoreOpenHoursForDay(this.selectedStore, this.reservationDate.toDateString());
      // null if its a day that doesn't have opening hours

      this.selectedStore._openHour = openingandClosingHours.openHours;
      this.selectedStore._closedHour = openingandClosingHours.closeHours;
    } catch (error) {
      //console.log(error);
    }
    
    this.tempstoreEmployees = this.storeEmployees.filter(employee => employee.EmployeeSchedule.find(schedule => schedule.Day == this.reservationDate.getDay()) != undefined);
    this.selectedSection = undefined;
    this.selectedEmployee = undefined;
    this.showavavailableTimes = false;
  }

  getTimeIntervals(){
    let startString = this.getTimeFormat(this.selectedStore._openHour);
    let endString = this.getTimeFormat(this.selectedStore._closedHour);
    let timeInterval : string[] = [];
    for (let index = +startString.split(':')[0]; index < +endString.split(':')[0]; index++) {
      let stringAdd = "";
      if(index < 10){
        stringAdd = "0";
      }
      if(index == +startString.split(':')[0] && (+startString.split(':')[1]) != 0 ){
        if( (+startString.split(':')[1]) <= 30 ){
          let timeString2 = stringAdd+""+index+":30";
          timeInterval.push(timeString2); 
        }
      }
      else{
          let timeString1 = stringAdd+""+index+":00";
          let timeString2 = stringAdd+""+index+":30";
          timeInterval.push(timeString1); 
          timeInterval.push(timeString2);
      }
     
    }
    return timeInterval;
  }

  getTimeFormat(time : string){

    let timeString : string;
    let meridian : string;
    if(time.length == 6){
      timeString = time.substring(0, 4);
      meridian = time.substring(4,6);
    }else{
      timeString = time.substring(0, 5);
      meridian = time.substring(5,7);
    }
    if(meridian == 'am'){
      let updatedTime : number = +timeString.split(':')[0];
      if(updatedTime == 12){
        updatedTime = 0;
        return updatedTime+":"+timeString.split(':')[1];
      }
      return timeString;
    }else{
      let updatedTime : number = +timeString.split(':')[0];
      if(updatedTime < 12){
        updatedTime += 12;
      }
      return updatedTime+":"+timeString.split(':')[1];
    }
  }
  


  async checkAvailableTimesForDate(){
    const loader = await this.loaderService.create();
    await loader.present();

    this.showavavailableTimes = false;

    this.errorMessage = false;
    if(this.reservationGuests < 1){
      this.openSnackBar("Please enter valid guest Count", "close");
      loader.dismiss();
      return;
    }
    if(this.reservationGuests > this.storeLayout.OnlineReservationLimit){
      
      this.errorMessage = true;
      loader.dismiss();
      return;
    }
    if(this.storeLayout.SectionsIncluded == true && this.selectedSection == undefined){
      this.openSnackBar("Please select section", "close");
      loader.dismiss();
      return;
    }
    if(this.storeLayout.EmployeesIncluded == true && this.selectedEmployee == undefined){
      this.openSnackBar("Please select employee", "close");
      loader.dismiss();
      return;
    }
    if(this.storeLayout.AllowDifferentLayouts == true && this.selectedLayout == undefined){
      this.openSnackBar("Please select layout", "close");
      loader.dismiss();
      return;
    }
  
    let timeInterval = this.storeLayout.ReservationTimeInterval;
    let currentAvailableTimes : Date[] = [];
    
    // comment this and resume the changes after the current fixes are sent
    /*
    let startString = this.getTimeFormat(this.selectedStore._openHour);
    let endString = this.getTimeFormat(this.selectedStore._closedHour);
   
    let startTime = new Date(this.reservationDate.getFullYear(), this.reservationDate.getMonth(), this.reservationDate.getDate());
    startTime.setHours(+startString.split(':')[0]);
    startTime.setMinutes(+startString.split(':')[1]);

    let endTime = new Date(this.reservationDate.getFullYear(), this.reservationDate.getMonth(), this.reservationDate.getDate());
    endTime.setHours(+endString.split(':')[0]);
    endTime.setMinutes(+endString.split(':')[1]);
  
    endTime.setMinutes(endTime.getMinutes() - timeInterval);
    */

    let inputDate = new Date(this.reservationDate.getFullYear(), this.reservationDate.getMonth(), this.reservationDate.getDate());

    currentAvailableTimes = this.LookForDaysWithAvailability(timeInterval, currentAvailableTimes);
    /*
    for (let time = startTime; time <= endTime; time.setMinutes(time.getMinutes() + timeInterval)) {
     
      if(time > new Date()){
        let tempTime = new Date(time.getFullYear(), time.getMonth(), time.getDate(),time.getHours(),time.getMinutes());
        let tempStore : IStore = JSON.parse(JSON.stringify(this.selectedStore));
        let isStoreavailable = this.storeService.isStoreOpenSpecificDayAndTime(tempStore,tempTime.toDateString(),tempTime.toLocaleTimeString(),timeInterval);
        if(isStoreavailable){
          if(this.selectedEmployee == undefined){
            currentAvailableTimes.push(tempTime);
          }
          else{
            let employeeAvailable : boolean = false;
            let employeeSchedle : IEmployeeSchedule =  this.selectedEmployee.EmployeeSchedule.find(schedule => schedule.Day == this.reservationDate.getDay());
            employeeSchedle.TimeRange.forEach(timeRange => {
              let tempDate = new Date(time.getFullYear(), time.getMonth(), time.getDate());
              if(+this.setDateTime(tempDate,timeRange.StartTime) == +tempTime || (this.setDateTime(tempDate,timeRange.StartTime) < tempTime &&  this.setDateTime(tempDate,timeRange.EndTime) > tempTime)){
                employeeAvailable = true;
              }
            });
  
            if(employeeAvailable){
              currentAvailableTimes.push(tempTime);
            }
          }
          
        }
      }
    }
    */

    this.availableTimes = [];
    if(currentAvailableTimes.length < 1){
      this.showavavailableTimes = true;
      loader.dismiss();
      return;
    }
    
    for(var i = 0; i < currentAvailableTimes.length; i++) {
      try {
        let tableAvailble = await this.getAvailability(currentAvailableTimes[i]);
        //let tableAvailble = false;

        if(!tableAvailble) {
          var attemptSuccess = false;
          var attempt = 0;
          while (attempt < 3) {
            tableAvailble = await this.getAvailability(currentAvailableTimes[i]);
            attempt++;
          }

          if(!attemptSuccess) {
            console.log(this.availableTimes);
            this.showavavailableTimes = true;
            loader.dismiss();
            break;
          }
        }

        if(tableAvailble){
          this.availableTimes.push(currentAvailableTimes[i]);
        }
        this.availableTimes.sort();
        
      } catch(exception) {
        //console.log(exception);
      }


      if(this.availableTimes.length > 0 || i == currentAvailableTimes.length - 1){
        this.showavavailableTimes = true;
      }
    }

    loader.dismiss();

    /*
    currentAvailableTimes.forEach(async (element, index) => {
      try {
        let tableAvailble = await this.getAvailability(element);
        //let tableAvailble = false;

        console.log(tableAvailble);

        if(tableAvailble){
          this.availableTimes.push(element);
        }
        this.availableTimes.sort();
        
      } catch(exception) {
        //console.log(exception);
      }


      if(this.availableTimes.length > 0 || index == currentAvailableTimes.length - 1){
        this.showavavailableTimes = true
      }
    });
    */
  
    //this.showavavailableTimes = true;
  }

  LookForDaysWithAvailability(timeInterval, currentAvailableTimes,  recursiveAttempts?){

    // this ensures that the store has open hours
    if(this.selectedStore._openHour && this.selectedStore._closedHour) {

      //////////////////////////////////////////////////////////////////////////////
      // this part here gets the open hours and sets the time
      let startString = this.getTimeFormat(this.selectedStore._openHour);
      let endString = this.getTimeFormat(this.selectedStore._closedHour);

      let startTime = new Date(this.reservationDate.getFullYear(), this.reservationDate.getMonth(), this.reservationDate.getDate());
      startTime.setHours(+startString.split(':')[0]);
      startTime.setMinutes(+startString.split(':')[1]);

      let endTime = new Date(this.reservationDate.getFullYear(), this.reservationDate.getMonth(), this.reservationDate.getDate());
      endTime.setHours(+endString.split(':')[0]);
      endTime.setMinutes(+endString.split(':')[1]);
    
      endTime.setMinutes(endTime.getMinutes() - timeInterval);
      //////////////////////////////////////////////////////////////////////////////


      // this part processes the available time and sets it in the "currentAvailableTimes"
      for (let time = startTime; time <= endTime; time.setMinutes(time.getMinutes() + timeInterval)) {
        if(time > new Date()){
          let tempTime = new Date(time.getFullYear(), time.getMonth(), time.getDate(),time.getHours(),time.getMinutes());
          let tempStore : IStore = JSON.parse(JSON.stringify(this.selectedStore));
          let isStoreavailable = this.storeService.isStoreOpenSpecificDayAndTime(tempStore,tempTime.toDateString(),tempTime.toLocaleTimeString(),timeInterval);

          if(isStoreavailable){
            if(this.selectedEmployee == undefined){
              currentAvailableTimes.push(tempTime);
            } else {
              let employeeAvailable : boolean = false;
              let employeeSchedle : IEmployeeSchedule =  this.selectedEmployee.EmployeeSchedule.find(schedule => schedule.Day == this.reservationDate.getDay());
              employeeSchedle.TimeRange.forEach(timeRange => {
                let tempDate = new Date(time.getFullYear(), time.getMonth(), time.getDate());
                if(+this.setDateTime(tempDate,timeRange.StartTime) == +tempTime || (this.setDateTime(tempDate,timeRange.StartTime) < tempTime &&  this.setDateTime(tempDate,timeRange.EndTime) > tempTime)){
                  employeeAvailable = true;
                }
              });
    
              if(employeeAvailable){
                currentAvailableTimes.push(tempTime);
              }
            }
            
          }
        }
      }


      //finaly, this part checks how many days it attempted to find available times, it only goes for 7 days and if it still can't find places, it'll give the error message.
      if(currentAvailableTimes.length < 1 && recursiveAttempts != 7) {
        
        startTime.setDate(startTime.getDate() + 1);

        this.reservationDate = startTime;

        if(!recursiveAttempts) {
          recursiveAttempts = 0;
        }
        recursiveAttempts++;

        this.TimedDateChangeWarning();

        this.getOpenHours(startTime);

        
        return this.LookForDaysWithAvailability(timeInterval, currentAvailableTimes, recursiveAttempts);
      } else {


        return currentAvailableTimes;
      }

    } else {

      this.ChangedDate = false;

      return [];
    }

    

  }

  TimedDateChangeWarning(){
    this.ChangedDate = true;
    setTimeout(() => {
      this.ChangedDate = false;
    }, 20000); 
  }

  checkAvailability(inputDate){
    
    this.reservationDate = inputDate;
    //console.log(this.reservationDate.getFullYear() + "-" + (this.reservationDate.getMonth() + 1) + "-" + this.reservationDate.getDate())
    // console.log(this.reservationDate);
    var sectionId = "N/A";
    var layout = null;
    if(this.storeLayout.SectionsIncluded){
      sectionId = this.selectedSection.Id;
    }
    if(this.storeLayout.AllowDifferentLayouts){
      layout = this.selectedLayout;
    }
    let findAvailability : IFindTableAvailability = {
      totalGuests : this.reservationGuests,
      reservationTime : inputDate,
      StoreId : this.selectedStore.id,
      SectionId : sectionId,
      Layout: layout
    }
    this.reservationService.getTableAvailability(findAvailability).subscribe(data =>{
      if(data != null && data.length > 0){
        this.availability = true;
        this.showavavailableTimes = false;
        this.openSnackBar("Tables are available at the selected Time", "close");
      }
      else{
        this.openSnackBar("No availability at selected time", "close");
      }
    })
  }

  DateTimeBuilder() {
    var screenWidth = window.innerWidth;

    const date = new Date(this.reservationDate.toDateString());

    if(screenWidth < 520) {

      var language = "";
      if(this.translationService.getLanguage() == "fr") {
        language = 'fr-FR';
      } else {
        language = 'en-US';
      }

      const formattedDate = date.toLocaleDateString(language, {
        year: 'numeric',
        month: 'long', // full month name (e.g., March)
        day: 'numeric',
      });

      return formattedDate;
    } else {

      var language = "";
      if(this.translationService.getLanguage() == "fr") {
        language = 'fr-FR';
      } else {
        language = 'en-US';
      }

      // Use toLocaleDateString to format the date with day, month, and year
      const formattedDate = date.toLocaleDateString(language, {
        weekday: 'long', // full weekday name (e.g., Monday)
        year: 'numeric',
        month: 'long', // full month name (e.g., March)
        day: 'numeric',
      });

      return formattedDate;
    }
  }


  redoAvailability(){
    this.availability = false;
    this.guestName = "";
    this.guestPhone = "";
    this.guestEmail = "";
    this.countBooster = 0;
    this.countChildren = 0;
    this.countHighChair = 0;
    this.specialRequests = "";
    this.tempstoreEmployees = this.storeEmployees;
    this.reservationDate = new Date();
    this.reservationClicked = false;
    this.selectedSection = undefined;
    this.selectedEmployee = undefined;
    this.selectedLayout = undefined;
    this.reservationSuccessfull = false;
    this.showavavailableTimes = false;
    this.countSelectedPackages = 0;
    this.reservationSectionPackages = [];
  }
  reserve(){
    if(this.guestName == "" || this.guestName.length > 20){
      this.openSnackBar("Please enter valid name","close");
      return;
    }
    if(this.guestPhone.length < 10 || this.guestPhone.length > 10 || this.guestPhone == "" ){
      this.openSnackBar("Please enter a valid phone number", "close");
      return;
    }
    if(this.guestEmail != "" && !this.guestEmail.includes("@") ){
      this.openSnackBar("Please enter valid email","close");
      return;
    }
    if(this.specialRequests.length > 100){
      this.openSnackBar("character limit for special request is 100","close");
      return;
    }
    if(this.countChildren < 0 || this.countChildren > this.reservationGuests){
      this.openSnackBar("Please enter valid children count (cannot be more than number of guests)","close");
      return;
    }
    if(this.countBooster < 0 || this.countHighChair < 0 || this.countBooster + this.countHighChair > this.reservationGuests){
      this.openSnackBar("Please enter valid booster and high chair count (sum cannot be more than number of guests)","close");
      return;
    }
    this.reservationClicked = true;
    var reservationConfirmation = true;
    if(this.storeLayout.EmailValidationRequired){
      reservationConfirmation = false;
    }
    var sectionId = "N/A";
    if(this.storeLayout.SectionsIncluded){
      sectionId = this.selectedSection.Id;
    }
    var employeeId = -1;
    if(this.selectedEmployee != undefined){
      employeeId = this.selectedEmployee.EmployeeId;
    }
    var layout = null;
    if(this.storeLayout.AllowDifferentLayouts){
      layout = this.selectedLayout;
    }
    let createReservationModel : ICreateReservation = {
      locationId : +this.selectedStore.externalProviderId,
      name: this.guestName,
      date: this.reservationDate.getFullYear() + "-" + (this.reservationDate.getMonth() + 1) + "-" + this.reservationDate.getDate(),
     // time: this.reservationHour,
      time : this.reservationDate.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'}),
      count: this.reservationGuests,
      countChildren: this.countChildren,
      countHighChair: this.countHighChair,
      countBooster: this.countHighChair,
      specialRequest: this.specialRequests,
      email: this.guestEmail,
      phone: this.guestPhone,
      byMerchant: false,
      pageId: +this.settingService.getSmaPageId(),
      storeId: this.selectedStore.id,
      sectionId : sectionId,
      reservationConfirmation: reservationConfirmation,
      language: this.translationService.getLanguage(),
      employeeId: employeeId,
      packages: this.reservationSectionPackages,
      layout: layout
    }

    this.reservationService.createReservation(createReservationModel).subscribe(data=>{
      if(data == "\"N/A\""){
        this.openSnackBar("Reservation failed", "close");
      }
      else{
        this.reservationSuccessfull = true;
        this.openSnackBar("Reservation successful", "close");
        this.reservationService.notifyCreateReservation(data.split('"').join('')).subscribe();
      }
    });
  }

  async tablesAvailable(time) {
    try {
      let tableAvailble = await this.getAvailability(time);
      return tableAvailble;
    } catch(exception) {
      console.log(exception);
    }
  }

  setDateTime(date : Date, time : string) {
    let index = time.indexOf(":"); // replace with ":" for differently displayed time.
    let index2 = time.indexOf(" ");

    let hours = +time.substring(0, index);
    let minutes = +time.substring(index + 1, index2);

    let mer = time.substring(index2 + 1, time.length);
    if(mer == "AM" && hours == 12){
        hours = 0;
    }
    if (mer == "PM" && hours != 12){
        hours = hours + 12;
    }
    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(0);

    return date;
  }

  public getAvailability(time) : Promise<Boolean> {
    return new Promise((resolve, reject) => {
      var sectionId = "N/A";

      if(this.storeLayout.SectionsIncluded){
        sectionId = this.selectedSection.Id;
      }

      let findAvailability : IFindTableAvailability = {
        totalGuests : this.reservationGuests,
        reservationTime : time,
        StoreId : this.selectedStore.id,
        SectionId : sectionId,
        Layout: this.selectedLayout
      }

      this.reservationService.getTableAvailability(findAvailability).subscribe(data =>{
        if(data != null && data.length > 0){
            resolve(true);
            return;
        }
        else{
          
          resolve(false);
          return;
        }
        //reject(false);
      });

    }); 
  }

  addPackage(index){
    this.reservationSectionPackages[index].Quantity += 1;
    this.countSelectedPackages += 1;
  }

  removePackage(index){
    this.reservationSectionPackages[index].Quantity -= 1;
    this.countSelectedPackages -= 1;
  }

  getPackageImage(sectionPackage: IReservationSectionPackage){
    if (sectionPackage.ItemImageShortName != null && sectionPackage.ItemImageShortName != "") {
      return 'url(' + this.settingService.apiUrl("/Menu/GetMenuItemImage?name=" + sectionPackage.ItemImageShortName) + ')';
    } 
  }

  toggleDescriptionView(index){
    var description = document.getElementById("description" + index);
    if(description.classList.contains("open")){
      description.classList.remove("open");
    } else {
      description.classList.add("open");
    }
    var note = document.getElementById("note" + index);
    if(note.classList.contains("show-note")){
      note.classList.remove("show-note");
    } else {
      note.classList.add("show-note");
    }
  }

  async cart(){
    if(this.guestName == "" || this.guestName.length > 20){
      this.openSnackBar("Please enter valid name","close");
      return;
    }
    if(this.guestPhone.length < 10 || this.guestPhone.length > 10 || this.guestPhone == "" ){
      this.openSnackBar("Please enter a valid phone number", "close");
      return;
    }
    if(this.guestEmail != "" && !this.guestEmail.includes("@") ){
      this.openSnackBar("Please enter valid email","close");
      return;
    }
    if(this.specialRequests.length > 100){
      this.openSnackBar("character limit for special request is 100","close");
      return;
    }
    if(this.countChildren < 0 || this.countChildren > this.reservationGuests){
      this.openSnackBar("Please enter valid children count","close");
      return;
    }
    if(this.countBooster < 0 || this.countBooster > this.reservationGuests){
      this.openSnackBar("Please enter valid booster count","close");
      return;
    }
    if(this.countHighChair < 0 || this.countHighChair > this.reservationGuests){
      this.openSnackBar("Please enter valid high chairs count","close");
      return;
    }
    
    const modal = await this.modalController.create({
      component: ReservationCartModalComponent,
      componentProps: {
        reservationSectionPackages: this.reservationSectionPackages,
        store: this.selectedStore,
        date: this.reservationDate
      }
    });
    modal.onWillDismiss()
      .then(async (result) => {
        if (!result.data)
          return;
        if(result.data){
          if (!this.authService.isAuthenticated) {
            this.proceedGuest();
            return;
          }
          this.checkout();
        }
      });

    await modal.present();
  }

  async proceedGuest() {
    if (this.settingService.configuration.hideMemberProgram) {
      this.checkout();
      return;
    }

    const modal = await ProceedAsGuestModalComponent.open(this.modalController);
    modal.onWillDismiss()
      .then((result) => {
        if (result.data.cancelCart) {
          return;
        } 
        this.checkout();
      });
  }

  async checkout(){
    const modal = await this.modalController.create({
      component: ReservationCheckoutModalComponent,
      componentProps: {
        reservationSectionPackages: this.reservationSectionPackages,
        specialRequest: this.specialRequests,
        store: this.selectedStore,
        reservationDate: this.reservationDate.getFullYear() + "-" + (this.reservationDate.getMonth() + 1) + "-" + this.reservationDate.getDate(),
        reservationTime: this.reservationDate.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})
      },
      cssClass: 'fullscreen'
    });
    modal.onWillDismiss()
      .then(async (result) => {
        if (!result.data)
          return;
        
        this.reservationClicked = true;
        var sectionId = "N/A";
        if(this.storeLayout.SectionsIncluded){
          sectionId = this.selectedSection.Id;
        }
        var employeeId = -1;
        if(this.selectedEmployee != undefined){
          employeeId = this.selectedEmployee.EmployeeId;
        }
        var layout = null;
        if(this.storeLayout.AllowDifferentLayouts){
          layout = this.selectedLayout;
        }
        let createReservationModel : ICreateReservation = {
          locationId : +this.selectedStore.externalProviderId,
          name: this.guestName,
          date: this.reservationDate.getFullYear() + "-" + (this.reservationDate.getMonth() + 1) + "-" + this.reservationDate.getDate(),
          time : this.reservationDate.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'}),
          count: this.reservationGuests,
          countChildren: this.countChildren,
          countHighChair: this.countHighChair,
          countBooster: this.countHighChair,
          specialRequest: this.specialRequests,
          email: this.guestEmail,
          phone: this.guestPhone,
          byMerchant: false,
          pageId: +this.settingService.getSmaPageId(),
          storeId: this.selectedStore.id,
          sectionId : sectionId,
          reservationConfirmation: true,
          language: this.translationService.getLanguage(),
          employeeId: employeeId,
          packages: this.reservationSectionPackages,
          layout: layout
        }
    
        this.reservationService.createReservation(createReservationModel).subscribe(data=>{
          if(data == "N/A"){
            this.openSnackBar("Reservation failed", "close");
          }
          else{
            this.reservationService.getAgendaInfo(data.split('"').join('')).subscribe((agenda) => {
              agenda.PrepayReservation = result.data.prepayReservation;
              this.reservationService.updateReservation(agenda).subscribe(() => {
                this.reservationSuccessfull = true;
                this.openSnackBar("Reservation successful", "close");
                this.reservationService.notifyCreateReservation(data.split('"').join('')).subscribe();
                this.showReceipt(result.data);
              })
            });
          }
        });
      });
    await modal.present();
  }

  async showReceipt(receipt: ICustomerReservationTransactionEmail) {
    const modal = await this.modalController.create({
      component: ReservationReceiptComponent,
      componentProps: {
        customerReservationTransactionEmail: receipt
      },
      cssClass: 'fullscreen'
    });

    await modal.present();
  }


  validTimeDifference(store: IStore): boolean {
    if(!store.lastOnline) return false;
    let oneSecond = 1000;
    let currentDate = new Date();
    let timeDifference = currentDate.getTime() - new Date(store.lastOnline).getTime();
    let seconds = Math.round(timeDifference / oneSecond);
    return seconds <= 60;
  }

  isOpen(store: IStore): boolean {
    let currentDate = new Date();
    return this.storeService.isStoreOpenSpecificDayAndTime(store, currentDate.toDateString(), currentDate.toLocaleTimeString());
  }

  displayReservationAlert(templateRef: TemplateRef<any>, store: IStore){
    this.clickedStorePhone = store.phone;
    this.dialog.open(templateRef);
  }

  callStore(){
    let telURI = "tel:" + this.clickedStorePhone.number;
    if(this.clickedStorePhone.extension != ""){
      telURI += "," + this.clickedStorePhone.extension;
    }
    window.location.href = telURI;
  }

  ngOnDestroy(): void {
      clearInterval(this.refreshStoresInterval);
  }

  closePopup(){
    if(this.isPopup) {
      this.modalController.dismiss();
    }
  }
}

// async checkAvailableTimes(){
//   this.errorMessage = false;
//   //console.log(this.storeLayout);
//   if(this.reservationGuests < 1){
//     this.openSnackBar("Please enter valid guest Count", "close");
//     return;
//   }
//   if(this.reservationGuests > this.storeLayout.OnlineReservationLimit){
    
//     this.errorMessage = true;
//     return;
//   }
//   let inputDate = new Date(this.reservationDate.getFullYear(), this.reservationDate.getMonth(), this.reservationDate.getDate());
//   inputDate.setHours(+this.reservationHour.split(':')[0]);
//   inputDate.setMinutes(+this.reservationHour.split(':')[1]);
 
//   if(inputDate <= new Date()){
//     this.openSnackBar("Please enter valid time", "close");
//     return;
//   }

//   let timeInterval = this.storeLayout.ReservationTimeInterval;
//   this.availableTimes = [];
//   let currentAvailableTimes : Date[] = [];
  
//   currentAvailableTimes.push(new Date(inputDate.getFullYear(), inputDate.getMonth(), inputDate.getDate(),inputDate.getHours(),inputDate.getMinutes()-timeInterval));
//   currentAvailableTimes.push(inputDate);
//   currentAvailableTimes.push(new Date(inputDate.getFullYear(), inputDate.getMonth(), inputDate.getDate(),inputDate.getHours(),inputDate.getMinutes()+timeInterval));
//   currentAvailableTimes.push(new Date(inputDate.getFullYear(), inputDate.getMonth(), inputDate.getDate(),inputDate.getHours(),inputDate.getMinutes()+(2 * timeInterval)));
  
//   currentAvailableTimes.forEach(async element => {
//     try {
//       let tableAvailble = await this.getAvailability(element);
//      if(tableAvailble){
//       console.log("in availability");
//       this.availableTimes.push(element);
//      }
//      this.availableTimes.sort();
//     } catch(exception) {
//       console.log(exception);
//     }
//   });
  
//   //console.log(this.availableTimes);
//   this.showavavailableTimes = true;
// }